$(document).ready(function(){
    var collection_slide = new Swiper(".collection-slide .swiper-container", {
        speed:1000,
        loop: false,
        autoplay: false,
        slidesPerView:4.3,
        spaceBetween: 22,           
        slidesOffsetAfter:0,
        navigation: {
            nextEl: '.collection-slide .swiper-button-next',
            prevEl: '.collection-slide .swiper-button-prev',
        },
        scrollbar: {
            el: '.collection-slide .swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            1200: {
                slidesPerView:4.1,
                spaceBetween: 16,           
                slidesOffsetAfter:0,
            },
            990: {
                slidesPerView:3.03,
                spaceBetween: 16,           
                slidesOffsetAfter:20,
            },
            550: {
                slidesPerView:3.2,
                spaceBetween: 16,           
                slidesOffsetAfter:20,
            },
            0:{
                slidesPerView:1.5,
                spaceBetween: 8,                
                slidesOffsetAfter:20,
            }
        },
        observer: true,   
        observeParents: true,
    });

    
    function setEqualHeight() {
        var maxHeight = 0;
        var maxTitleHeight = 0;
        $('.card_info_top').css('height', 'auto');
        
        $('.card_info_top').each(function() {
            var thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });
        //$('.card__heading').css('height', maxTitleHeight*0.5 + 'px');
        $('.card_info_top').css('height', (maxHeight) + 'px');
    }

    $(document).ready(function() {
        setEqualHeight();
        setInterval(function(){
            
            setEqualHeight();

        },1000)
    });

    $(window).on('resize', function() {
        setEqualHeight();
    });

    $('.collection-slide-tab-title li').click(function(){
        $('.collection-slide-tab-title li').removeClass('active');
        $(this).addClass('active');

        const collectionIdx = $(this).index()+1;
        $('.collection-slide-tab-content slider-component').hide();
        $('.collection-slide-tab-content slider-component:nth-of-type('+collectionIdx+')').show();

    })
});

// 리뷰없을 때 상품하단 노출
$('.bestNew .swiper-wrapper .swiper-slide').each(function() {
    const $item = $(this);

    setTimeout(() => {
        const $wrapper = $item.find('.card__information .yotpo-display-wrapper');

        if ($wrapper.find('.standalone-bottomline').length > 0) {
        return;
        }
        if ($wrapper.siblings('.no-review-message').length > 0) {
        return;
        }

        $wrapper.after(`<div class="no-review-message"><p style="text-align:center;"><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span></p><p style="text-align:center;color:#000;padding-top:5px;font-size:13px;">( 0 レビュー )</p></div>`);

    }, 2000);
});